import "./MyRatings.scss";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import React, { useEffect, useState } from "react";
import { StarIcon } from "../../../../Assets/svgIcons";
import { useAuth } from "../../../../Contexts/auth.context";
import Button from "../../../../components/button/button.component";
import Loading from "../../../../components/loading/loading.component";
import { CMAuctions } from "../../../Public/billing-history/billing-history.styles";
import {
  addInfluencerComments,
  getInfluencerRating,
} from "../../../../Services/prod/auth.service";

const MyRatings = ({ activeTab }) => {
  // *********** STATES ***********
  const limit = 10;
  const { auth } = useAuth();
  const [page, setPage] = useState(1);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(true);
  const [viewMore, setViewMore] = useState(null);
  const [loadingComment, setLoadingComment] = useState(false);
  const [influencerRating, setInfluencerRating] = useState({});

  // *********** GET INFLUENCER RATING API ***********
  const getProfile = async () => {
    try {
      if (auth?.userId) {
        const influencerRes = await getInfluencerRating(
          page,
          limit,
          auth?.userId
        );
        if (influencerRes?.status === 200 || influencerRes?.status === 201) {
          setLoading(false);
          setInfluencerRating(influencerRes?.data);
        }
      }
    } catch (error) {
      setLoading(false);
      console.log(error, "error");
    }
  };

  useEffect(() => {
    if (activeTab === "my-rating") {
      getProfile();
    }
  }, [activeTab, page]);

  // *********** HANDLE PAGE  ***********
  const handlePageAll = ({ selected }) => {
    setPage(selected + 1);
  };

  //   *********** FOR ADD COMMENTS IN INFLUENCER RATINGS ***********
  const handleAddComments = async (id) => {
    try {
      setLoadingComment(true);
      const addCommentPayload = {
        rating_id: id,
        comment: comment,
      };
      const addCommentRes = await addInfluencerComments(addCommentPayload);
      if (addCommentRes?.status === 200 || addCommentRes?.status === 201) {
        toast.success(addCommentRes?.message);
        setLoadingComment(false);
        getProfile();
        setViewMore(null);
        setComment("");
      } else {
        toast.error(addCommentRes?.message);
        setLoadingComment(false);
        console.log("***** API ERROR *****");
      }
    } catch (error) {
      setLoadingComment(false);
      console.log(error, "error");
    }
  };

  return (
    <div className="my_ratings_tab">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="my_ratings_heading">
            <h6>{influencerRating?.average_rating}</h6>
            {/* {Array.from({ length: 5 }).map((_, index) => (
              <StarIcon
                className={`${
                  index + 1 == influencerRating?.average_rating ? "active" : ""
                } star_icon`}
                key={index}
              />
            ))} */}
            <div className="rating_in_stars">
              <div className="rating_in_stars_original">
                {Array.from({ length: 5 }).map((_, index) => {
                  const rating = influencerRating?.average_rating || 0;
                  const showRating = Math.floor(rating); // Number of fully filled stars
                  const fractionalPart = rating - showRating; // Fractional part of the rating
                  return (
                    <StarIcon
                      className={`active star_icon`}
                      style={{
                        clipPath: `inset(0 ${
                          index < showRating
                            ? 0 // Fully filled
                            : index === showRating // Partially filled star
                            ? 100 - fractionalPart * 100
                            : 100 // Completely unfilled
                        }% 0 0)`,
                      }}
                      key={index}
                    />
                  );
                })}
              </div>
              <div className="rating_in_stars_copy">
                {Array.from({ length: 5 }).map((_, index) => {
                  return <StarIcon className={`star_icon`} key={index} />;
                })}
              </div>
            </div>
            <p>{influencerRating?.count} ratings</p>
          </div>
          <div className="rating_details">
            <h3>Rating Details </h3>
            <ul>
              {influencerRating && influencerRating?.rows?.length > 0 ? (
                influencerRating?.rows?.map((data, i) => (
                  <li>
                    <div className="rating_details_box">
                      <div className="rating_details_box_stars">
                        {Array.from({ length: 5 }).map((_, index) => (
                          <StarIcon
                            className={`${
                              index + 1 <= data?.rating ? "active" : ""
                            } star_icon`}
                            key={index}
                          />
                        ))}
                        <p>{data?.rating ? data?.rating : 0}</p>
                      </div>
                      <p className="desc_txt">
                        {data?.commit ? data?.commit : "N/A"}
                      </p>
                      {data?.replies?.length !== 0 && (
                        <>
                          {viewMore !== i && (
                            <button
                              onClick={() => setViewMore(i)}
                              type="button"
                              className="view_btn"
                            >
                              View Comment
                            </button>
                          )}
                          {viewMore === i && (
                            <p
                              onClick={() => setViewMore(null)}
                              className="desc_txt reply_txt"
                            >
                              {data?.replies[0]?.commit}
                            </p>
                          )}
                        </>
                      )}
                      {data?.replies?.length === 0 && (
                        <>
                          {viewMore !== i && (
                            <button
                              onClick={() => setViewMore(i)}
                              type="button"
                              className="view_btn reply_btn"
                            >
                              Reply
                            </button>
                          )}
                          {viewMore === i && (
                            <>
                              <textarea
                                placeholder="Enter your comment"
                                className="reply_input"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                              />
                              {viewMore === i &&
                                comment.length > 0 &&
                                comment.length < 5 && (
                                  <div className="error">
                                    Comment must be at least 5 characters long.
                                  </div>
                                )}
                              {viewMore === i && comment.length > 100 && (
                                <div className="error">
                                  Comment cannot exceed 100 characters.
                                </div>
                              )}
                              <Button
                                onClick={() => handleAddComments(data?.id)}
                                type="button"
                                disabled={
                                  comment.length === 0 ||
                                  comment.length < 5 ||
                                  comment.length > 100
                                }
                                loading={loadingComment}
                                isProgressButton={loadingComment}
                              >
                                Send
                              </Button>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </li>
                ))
              ) : (
                <li>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <p
                      style={{
                        padding: "20px",
                        fontSize: "18px",
                      }}
                    >
                      No Records Found
                    </p>
                  </div>
                </li>
              )}
            </ul>
          </div>
          {influencerRating?.count > limit && (
            <CMAuctions>
              <section className="pagination custom_pagination">
                <ReactPaginate
                  breakLabel="..."
                  nextLabel=">"
                  previousLabel="<"
                  onPageChange={handlePageAll}
                  pageRangeDisplayed={3}
                  pageCount={Math.ceil(influencerRating?.count / limit)}
                  renderOnZeroPageCount={null}
                />
              </section>
            </CMAuctions>
          )}
        </>
      )}
    </div>
  );
};

export default MyRatings;
